import Link from "next/link";
import Image from "next/image";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaPinterest,
  FaTiktok,
  FaTwitter,
  FaYoutube,
} from "node_modules/react-icons/fa6";

const CurrentYear = () => {
  const date = new Date();
  return date.getFullYear();
};

export default function Footer() {
  return (
    <>
      <footer className="relative bg-getjar-darkorange from-getjar-darkorange to-getjar-orange h-auto text-white bg-right bg-no-repeat">
        <div
          className="container mx-auto py-8 px-4 grid grid-cols-1 md:grid-cols-4 gap-8"
          style={{
            backgroundImage:
              "url('https://strapistaticupload.s3.us-east-1.amazonaws.com/footer-right-bg.webp')",
            backgroundSize: "695px 305px",
            backgroundPosition: "right bottom", // Align to the bottom right
            backgroundRepeat: "no-repeat",
          }}
        >
          {/* First Column - Menu */}
          <div>
            <ul className="text-white text-base sm:text-sm">
              <li className="my-1">
                <Link className="uppercase text-white" href="/">
                  HOME
                </Link>
              </li>
              <li className="my-1">
                <Link className="uppercase text-white" href="/contactus">
                  CONTACT
                </Link>
              </li>
              <li className="my-1">
                <Link className="uppercase text-white" href="/categories">
                  CATALOG
                </Link>
              </li>
              <li className="my-1">
                <Link className="uppercase text-white" href="/info/terms">
                  TERMS AND CONDITIONS
                </Link>
              </li>
              <li className="my-1">
                <Link className="uppercase text-white" href="/info/privacy">
                  PRIVACY POLICY
                </Link>
              </li>
              <li className="my-1">
                <Link className="uppercase text-white" href="/info/cookie">
                  COOKIE POLICY
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <ul className="text-white text-base sm:text-sm">
              <li className="my-1">
                <Link
                  className="uppercase termly-display-preferences text-white"
                  href="#"
                >
                  CONSENT PREFERENCES
                </Link>
              </li>
              <li className="my-1">
                <Link
                  className="uppercase text-white"
                  href="https://app.termly.io/notify/d9b6123b-71ab-409f-928b-c18dc64eee2f"
                >
                  DO NOT SELL OR SHARE MY PERSONAL INFORMATION
                </Link>
              </li>
              <li className="my-1">
                <a className="uppercase text-white" href="/developers">
                  DEVELOPERS
                </a>
              </li>
            </ul>
          </div>

          {/* Second Column - Socials */}
          <div>
            <h3 className="text-white text-xl font-bold mb-4">Follow Us</h3>
            <div className="flex gap-4">
              <a
                href="https://www.facebook.com/GetJar/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook
                  width={48}
                  height={48}
                  className="hover:opacity-80"
                />
              </a>
              <a
                href="https://x.com/GetJar"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter
                  width={48}
                  height={48}
                  className="hover:opacity-80"
                />
              </a>
              <a
                href="https://www.instagram.com/getjarstore/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram
                  width={48}
                  height={48}
                  className="hover:opacity-80"
                />
              </a>
              <a
                href="https://www.linkedin.com/company/getjar-store/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin
                  width={48}
                  height={48}
                  className="hover:opacity-80"
                />
              </a>
              <a
                href="https://www.pinterest.com/get_jar/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaPinterest
                  width={48}
                  height={48}
                  className="hover:opacity-80"
                />
              </a>
              <a
                href="https://www.youtube.com/@Get_Jar"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube
                  width={48}
                  height={48}
                  className="hover:opacity-80"
                />
              </a>
              <a
                href="https://www.tiktok.com/@get_jar"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTiktok width={48} height={48} className="hover:opacity-80" />
              </a>
            </div>
          </div>

          {/* Third Column - Logo */}
          <div className="flex justify-end">
            <Image
              src="https://strapistaticupload.s3.us-east-1.amazonaws.com/getjar-logo-allwhite.svg"
              alt="GetJar Logo"
              width={250}
              height={100}
              className="max-h-[150px] w-auto"
            />
          </div>
        </div>
      </footer>

      {/* Copyright Section */}
      <div className="bg-slate-900 text-center text-slate-300 text-sm py-2">
        &copy; {CurrentYear()} GetJar.com. All rights reserved
      </div>
    </>
  );
}
